import React from 'react';
import { Col, Layout, message, Row, Select ,Icon} from 'antd';
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from 'js-export-excel';
const { Content } = Layout;
const { Option } = Select;
class PremiumVSmembers extends React.Component {
    columns = [{
        title: 'Plan Name',
        dataIndex: 'plan_name',
        sorter: (a, b) => a.plan_name.localeCompare(b.plan_name),
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Profile Name',
        dataIndex: 'profile_name',
        sorter: (a, b) => a.profile_name.localeCompare(b.profile_name),
        sortDirections: ["descend", "ascend"]
    },{
        title: 'Total Members',
        dataIndex: 'total_members',
        sorter: (a, b) =>a.total_members-b.total_members,
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Total Premium',
        dataIndex: 'total_premium',
        sorter: (a, b) => a.total_premium-b.total_premium,
        render:(text,record)=>"$"+text,
        sortDirections: ["descend", "ascend"]
    },
    ];
    constructor(props) {
        super(props);
        this.state = {
            carriers: null,
            PlanSummary: [],
            PreimumSummary: [],
            isLoading: false,
            client_id: null,
            year:new Date().getFullYear(),
            month:new Date().getMonth()+1,
            user_id: 0,
        }
        this.tableButtons = [{
            buttonType: "primary",
            content: "Export Excel",
            clickHandler: () => {
                this.downloadExcel();
            }
        }];
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    downloadExcel = () => {
        const data = this.state.PremiumVsmem ? this.state.PremiumVsmem.planSummaries : '';//tabular data
        var option = {};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if (data) {
                    let obj = {
                        'Plan Name': data[i].plan_name,
                        'Profile Name':data[i].profile_name,
                        'Total Members': data[i].total_members,
                        'Total Premium': "$"+data[i].total_premium,
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'PremiumVSmembers'
        option.datas = [
            {
                sheetData: dataTable,
                sheetName: 'sheet',
                sheetFilter: ['Plan Name','Profile Name',  'Total Members', 'Total Premium'],
                sheetHeader: ['Plan Name', 'Profile Name', 'Total Members', 'Total Premium'],
            }
        ];
        if(dataTable.length>0){
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }
    componentDidMount = () => {
        this.getClientMasters();
    }
    onChange = (type,e) => {
if(type==='carrier'){
this.setState({
    client_id:e
})
}
if(type==="month"){
    this.setState({
        month:e
    })
    }
    if(type==="year"){
        this.setState({
            year:e
        })
        }
setTimeout(() => {
    if(this.state.client_id&&this.state.month&&this.state.year){
        this.GetPremiumvsmem(this.state.client_id,this.state.year,this.state.month);
    }
}, 100);
    }
    GetPremiumvsmem(client_id,year,month) {
        this.setState({
            isLoading: true
        })
        this.api.invoke(
            "GetPremiunvsmembers/" + client_id+ "/" +month+ "/" +year,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        setTimeout(() => {
                            this.setState({
                                isLoading: false,
                                PremiumVsmem: data.data
                            })
                        }, 100);
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            });
    }
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    setTimeout(() => {
                        if(data.carriers[0])
                        this.GetPremiumvsmem(data.carriers[0]?data.carriers[0].id:null,this.state.year,this.state.month);
                    }, 100);
                    this.setState({
                        client_id: data.carriers[0]?data.carriers[0].id:null,
                        carriers: data.carriers,
                        months: data.months,
                        years: data.years
                    });
                }
            },
            ["CARRIER","MTH", "YR"]
        );
    }
    render() {
        return (
            <Content>
                <div className="mi_main_div">
                    <Row style={{ padding: '20px', background: 'white' }}>
                        <Col span={24}>
                            <p className="mi_table_title" style={{ textAlign: 'center', marginBottom: '40px' }}>Premium Received Vs Enrolled Members Report</p>
                        </Col>
                        <Col span={8} style={{ marginBottom: '40px' }}>
                            <Row span={24}>
                                {this.state.client_id ?
                                    <Col span={10} >
                                        <h3><b>Carrier : </b></h3>
                                        <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} style={{ width: '300px' }} className="mi_input_profile"
                                            onChange={this.onChange.bind(this,'carrier')}
                                            placeholder="Please Select Carrier *"
                                            showSearch={true}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            }
                                            defaultValue={this.state.client_id?this.state.client_id:undefined}
                                        >
                                            {this.state.carriers ? this.state.carriers.map((tag) => (
                                                <Option value={tag.id} key={tag.id}>
                                                    {tag.name.split(' ')
                                                        .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                                                        .join(' ')}
                                                </Option>
                                            )) : ''}
                                        </Select>
                                    </Col>
                                    : <Col span={10} ></Col>}
                            </Row>
                        </Col>
                        <Col span={8} style={{ padding: '0px 20px' }}>
                                    <h3><b>Month : </b></h3>
                                    <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                        onChange={this.onChange.bind(this, 'month')}
                                        placeholder="Please Select Month *"
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        defaultValue={this.state.month?this.state.month:undefined}
                                    >
                                        {this.state.months ? this.state.months.map((tag) => (
                                            <Option value={tag.id} key={tag.id}>
                                                {tag.name}
                                            </Option>
                                        )) : ''}
                                    </Select>
                                </Col>
                                <Col span={8} style={{ padding: '0px 20px' }}>
                                    <h3><b>Years : </b></h3>
                                    <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                        onChange={this.onChange.bind(this, 'year')}
                                        placeholder="Please Select Years *"
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        defaultValue={this.state.year?this.state.year:undefined}
                                    >
                                        {this.state.years ? this.state.years.map((tag) => (
                                            <Option value={tag.id} key={tag.id}>
                                                {tag.name}
                                            </Option>
                                        )) : ''}
                                    </Select>
                                </Col>
                        <Col span={24}>
                            <ReportTableWrapper rowKey="tier_profile_name" columns={this.columns} data={this.state.PremiumVsmem ? this.state.PremiumVsmem.planSummaries : null} loading={this.state.isLoading} buttons={this.tableButtons} search={true} />
                        </Col>
                        <Col span={24}>
                            <Row style={{ width: '400px', float: 'right', marginTop: '20px' }}>
                                <Col span={24}>
                                    <Row span={24}>
                                        <Col span={18} className='footertext'>Grand total of Enrolled Members :	</Col>
                                        <Col span={6} className='footertext'>{this.state.PremiumVsmem ?  this.state.PremiumVsmem.grand_Total_members : "0"}</Col>
                                    </Row>
                                    <Row span={24}>
                                        <Col span={18} className='footertext'>Grand total of Premium Received :	</Col>
                                        <Col span={6} className='footertext'>{this.state.PremiumVsmem ? "$" + this.state.PremiumVsmem.grand_Total_premium : "$0"}</Col>
                                    </Row>
                                   </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default PremiumVSmembers;